// Images
import crescentHero from "../images/CRESCENT_HERO.webp";
import crescentFonts from "../images/CRESCENT_FONTS.png";
import crescentPoster from "../images/CRESCENT_POSTER.webp";
import cover from "../images/cover.jpg";
import streetcultback from "../images/street-culture-back.jpg";
// Hidden project (Verbum)
// import verbumproject from "../images/verbum-project-image.webp";
// import verbumhistory from "../images/verbum-history-img.jpg";
// import verbumcard from "../images/verbum-test-card.jpg";
import aneteprojects from "../images/aneteprojects.jpg";
import anetelanding from "../images/anetelanding.jpg";
// Hidden project (BOOMBOX)
// import boomboxhome from "../images/boombox-home.webp";
// import boomboxhsongs from "../images/boombox-songs.webp";
import studlylanding from "../images/studly-landing.webp";
import studlyfooter from "../images/studly-footer.webp";
import ewgarticles from "../images/ewg-articles.webp";
import ewgdonate from "../images/ewg-donate.webp";
import ewglandingpr from "../images/ewg-landing-pr.webp";
import ewgarticlespr from "../images/ewg-articles-pr.webp";
import ewgdonatepr from "../images/ewg-donate-pr.webp";
import ewgnewspr from "../images/ewg-news-pr.webp";
import ewgtrafficpr from "../images/ewg-traffics-pr.webp";
import brandingtypograpgy from "../images/branding-typography.webp";
import brandinglogos from "../images/branding-logos.webp";
import arrow from "../images/arrow_svg.svg";
import arrowdiag from "../images/arrow_diag_svg.svg";
import rmlogo from "../images/RM-logo.svg";

// Videos
import streetcultvideo from "../images/street_culture_video.mp4";
import aneteportvideo from "../images/anete_portfolio_video.mp4";
// Hidden project (BOOMBOX)
// import boomboxvideo from "../images/boombox-video.mp4";
import studylvideo from "../images/studly-video.mp4";
import ewgvideo from "../images/ewg-video.mp4";
// Hidden project (Video – Product Launch)
// import motionvideoshort from "../images/motion-video-short.mp4";
// import motionvideo from "../images/motion-video.mp4";
import brandingvideo from "../images/branding-video.mp4";

// Crescent project
import crescentLogo from "../images/CRESCENT_LOGO.webp";
import crescentCross from "../images/CRESCENT_CROSS.webp";
import crescentProcess from "../images/CRESCENT_PROCESS.webp";
import crescentLogoVariant from "../images/CRESCENT_LOGO_VARIANT.webp";

// Verbum project (hidden)
// import verbumstructure from "../images/verbum-structure.webp";
// import verbumer from "../images/verbum-er.webp";
// import verbumdb from "../images/verbum-db.webp";
// import verbumregistration from "../images/verbum-registration.webp";
// import verbumcardcreation from "../images/verbum-card-creation.webp";

// Street Culture project
import skatemag1 from "../images/skate-mag-1.webp";
import skatemag2 from "../images/skate-mag-2.webp";
import skatemag3 from "../images/skate-mag-3.webp";
import skatemag4 from "../images/skate-mag-4.webp";

// Crescent website project
import crescentweblanding from "../images/crescent-web-landing.webp";
import crescentwebcastle from "../images/crescent-web-castle.webp";
import crescentwebvideo from "../images/crescent-web-video.mp4";

// Thr33 project
import threelanding from "../images/three-landing.webp";
import threedrinks from "../images/three-drinks.webp";
import threevideo from "../images/three-video.mp4";

export const media = {
  crescentHero,
  crescentFonts,
  crescentPoster,
  crescentLogo,
  crescentCross,
  crescentProcess,
  crescentLogoVariant,
  skatemag1,
  skatemag2,
  skatemag3,
  skatemag4,
  crescentweblanding,
  crescentwebcastle,
  crescentwebvideo,
  threelanding,
  threedrinks,
  threevideo,
  // verbumstructure,
  // verbumer,
  // verbumdb,
  // verbumregistration,
  // verbumcardcreation,
  cover,
  streetcultback,
  streetcultvideo,
  // verbumproject,
  // verbumhistory,
  // verbumcard,
  aneteportvideo,
  aneteprojects,
  anetelanding,
  // boomboxhome,
  // boomboxhsongs,
  // boomboxvideo,
  studlylanding,
  studylvideo,
  studlyfooter,
  ewgarticles,
  ewgvideo,
  ewgdonate,
  ewglandingpr,
  ewgarticlespr,
  ewgdonatepr,
  ewgnewspr,
  ewgtrafficpr,
  // motionvideoshort,
  // motionvideo,
  brandingvideo,
  brandingtypograpgy,
  brandinglogos,
  arrow,
  arrowdiag,
  rmlogo,
};
